import React, { Component, forwardRef } from 'react'
import './custom-style.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import MenuLeftNav from "./MenuLeftNav";
import { Field, FieldArray, reduxForm, getFormValues } from 'redux-form'
import asyncValidate from '../home/asyncValidate';
import Divider from '@material-ui/core/Divider';
import { connect } from "react-redux";
import { values } from 'lodash';
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import MaterialTable from 'material-table'
import SweetAlert from 'react-bootstrap-sweetalert';
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import { DropzoneDialog } from 'material-ui-dropzone';
import * as auth from "../../store/ducks/auth.duck";
import { Link } from "react-router-dom";
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import clsx from "clsx";
import Loader from 'react-loader-advanced';
// import Modal from './Modal';
import { Helmet } from 'react-helmet'
import { OverlayTrigger, Tooltip as BootstrapTooltip, Alert, Collapse, Fade } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { Button } from "@material-ui/core";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconButton, Tooltip, CircularProgress } from '@material-ui/core';
import UserCreateApi from '../../api/Scoreboardapi';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Autocomplete } from '@material-ui/lab';
import TextField from '@material-ui/core/TextField';
import axios from "axios";
import SimpleReactValidator from 'simple-react-validator';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import { FormLabel, Input } from '@material-ui/core';

import { emailFrequencyOptions } from "./emailFrequencyOptionsData";

const CancelToken = axios.CancelToken;
let cancel;

var QRCode = require('qrcode.react');
var isLoadFirstTime = 0;
var isChangedEvent = 0;

library.add(fas)

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
}))(MuiDialogActions);

const validate = values => {
    const errors = {}
    const requiredFields = [
        'name',
        'title',
        'new_password',

    ]
    requiredFields.forEach(field => {
        if (!values[field]) {
            errors[field] = 'This field is required'
        }
    })
    if (
        values.email &&
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
    ) {
        errors.email = 'Please enter valid email address'
    }
    if (
        values.phone &&
        !/^(0|[1-9][0-9]{9})$/i.test(values.phone)
    ) {
        errors.phone = 'Required 10 digits phone number'
    }
    if (values.extension && !/^\d*[.]?\d*$/i.test(values.extension)) {
        errors.extension = 'Please enter only numeric value'
    }
    if (!/^\S*$/i.test(values.new_password)) {
        errors.new_password = 'Please enter valid password'
    }
    if (!/^\S*$/i.test(values.confirm_password)) {
        errors.confirm_password = 'Please enter valid confirm password'
    }

    if (values.new_password != values.confirm_password) {
        errors.confirm_password = 'New Password and Confirm Password do not match';
    }
    // if (values.papType =='' || values.papType =='') {
    //     errors.papType = 'Please select PAP Portal use';
    // }
    if (
        values.NPI &&
        !/^[0-9]+$/i.test(values.NPI)
    ) {
        errors.NPI = 'Please enter only numeric values'
    }
    if (
        values.NPI && values.NPI.length > 25
    ) {
        errors.NPI = 'NPI numbers can not be more than 25 digits.'
    }
    return errors
}

const renderField = ({
    input,
    label,
    type,
    disabled,
    isReadOnly,
    placeholder,
    isAsterisk,
    button,
    options,
    meta: { asyncValidating, touched, error },
    maxlength,
}) => (
    <div className="formgroup">
        <div className="row">
            {/* <label className="custom-label col-sm-2 text-right" style={{ color: "#000", marginTop: 7 }}> {label}{isAsterisk && <sup className="text-danger"> *</sup>} </label> */}

            <div className="col-sm-9">
                <div className={asyncValidating ? 'async-validating' : ''}>
                    {type == 'select' ? <select {...input} className="form-control" >
                        {options.map((option, index) => {
                            return <option key={option.value} value={option.value}>{option.lable}</option>;
                        })}
                    </select>
                        : isReadOnly == "true" ?
                            <label style={{ color: "rgb(120 121 130)", marginTop: 7 }}>{input.value}</label>
                            :
                            <input {...input} type={type} placeholder={placeholder} maxLength={maxlength} disabled={disabled} className="form-control" />}
                    {touched && error && <span className="error-msg text-danger">{error}</span>}

                </div>
            </div>
        </div>
    </div>
)

const renderSelectField = ({
    input,
    label,
    type,
    disabled,
    isReadOnly,
    placeholder,
    isAsterisk,
    button,
    options,
    meta: { asyncValidating, touched, error },
    maxlength,
    selectedOption,
}) => (
    <div className="formgroup">
        <div className="row">
            <div className="col-sm-9">
                <div className={asyncValidating ? 'async-validating' : ''}>
                    <select {...input} className="form-control" >
                        {options.map((option, index) => {
                            return <option value={option.value}>{option.lable}</option>;
                        })}
                    </select>
                    {touched && error && <span className="error-msg text-danger">{error}</span>}
                </div>
            </div>
        </div>
    </div>
)

const renderChangePasswordField = ({
    input,
    label,
    type,
    disabled,
    isReadOnly,
    placeholder,
    isAsterisk,
    button,
    options,
    meta: { asyncValidating, touched, error },
    maxlength,
}) => (
    <div className="formgroup">
        <div className="row">
            {/* <label className="custom-label col-sm-2 text-right" style={{ color: "#000", marginTop: 7 }}> {label}{isAsterisk && <sup className="text-danger"> *</sup>} </label> */}

            <div className="col-sm-12">
                <div className={asyncValidating ? 'async-validating' : ''}>
                    {type == 'select' ? <select {...input} className="form-control" >
                        {options.map((option, index) => {
                            return <option key={option.value} value={option.value}>{option.lable}</option>;
                        })}
                    </select>
                        : isReadOnly == "true" ?
                            <label style={{ color: "rgb(120 121 130)", marginTop: 7 }}>{input.value}</label>
                            :
                            <input {...input} type={type} placeholder={placeholder} maxLength={maxlength} disabled={disabled} className="form-control" />}
                    {touched && error && <span className="error-msg text-danger">{error}</span>}

                </div>
            </div>
        </div>
    </div>
)

class profile extends Component {

    constructor(props) {
        super(props);
        this.state = {
            name: null,
            title: null,
            role: null,
            email: null,
            phone: null,
            extension: null,
            new_password: null,
            confirm_password: null,
            avatar: null,
            alert: null,
            open: false,
            files: [],
            isSaveProfile: false,
            isSaveProfileFail: false,
            isCancel: false,
            isimageName: null,
            imagePath: '',
            is64baseimage: null,
            IsDelete: false,
            papType: '',
            airviewName: '',
            airviewOrganizationName: '',
            encoreName: '',
            encoreSleepLab: '',
            isPapUser: 0,
            showModal: false,
            isLoading: false,
            NPI: '',
            imageExist: false,
            isShowQrModal: false,
            sleepScreenerLink: '',
            referralKey: '',
            visible: false,
            isChangePassword: false,
            value: '',
            copied: false,
            airviewNameCheckbox: false,
            encoreNameCheckbox: false,
            isErrorInAirView: false,
            isErrorInOrganizationName: false,
            isErrorInEncoreView: false,
            isErrorInEncoreSleepLab: false,
            isShowCareOrchestratorPhilipsInfo: false,
            organizations: [],
            referralOptions: [],
            facilityAddress: '',
            facilityCity: '',
            faciltiyState: '',
            facilityZip: '',
            facilityPhone: '',
            facilityFax: '',
            facilityKey: '',
            searchOrganization: [],
            organization: [],
            referral: [],
            isLoadingReferral: false,
            openModel: false,
            isPortalSettingModuleVisible: false,
            isLoadingDownloadPdf: false,
            files: []
            // newRefDataValue: [],

        }
        this.handleChange = this.handleChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);

        this.validator = new SimpleReactValidator({
            validators: {
                autoCompleteRequired: {  // name the rule
                    message: 'The :attribute field is required.',
                    rule: (val, params, validator) => {
                        if (!val.value) {
                            return false;
                        }
                    },
                }
            }
        });
    }

    handleQrModalShowHide = (index, sleepScreenerLink = '', referralKey = '') => {
        this.setState({
            isShowQrModal: !this.state.isShowQrModal,
            sleepScreenerLink: sleepScreenerLink,
            referralKey: referralKey,
        });
    }

    downloadQR = () => {
        const canvas = document.getElementById("big" + this.state.referralKey);
        const pngUrl = canvas
            .toDataURL("image/png")
            .replace("image/png", "image/octet-stream");
        let downloadLink = document.createElement("a");
        downloadLink.href = pngUrl;
        downloadLink.download = this.state.referralKey + ".png";
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    };

    downloadFile = (fileUrl) => {
        axios({
            url: fileUrl,
            method: 'GET',
            responseType: 'blob', // important
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', this.state.referralKey+'.pdf');
            document.body.appendChild(link);
            link.click();
        }).catch((e) => 
        {
            console.log('error',e)
            this.profileUpdateAlert('No document found', 'failure');
        });
    }

    downloadPDF = () => {
        this.setState({ isLoadingDownloadPdf: !this.state.isLoadingDownloadPdf })
        let authToken = JSON.parse(localStorage.getItem("persist:userData")).authToken;
        var user = JSON.parse(JSON.parse(localStorage.getItem("persist:userData")).user);

        const options = {
            headers: { 'Content-Type': "application/json", 'AccessToken': `${authToken.replaceAll('"', '')}`, "UserId": `${user.userId}` },
            params: {
                "FacilityName": this.state.referralKey,
                "ScreenerLink": this.state.sleepScreenerLink
            }
        }
        axios.get(`${process.env.REACT_APP_API_URL}api/dashboard/getflayerforsleepscreener`, options)
            .then((res) => {
                this.setState({ isLoadingDownloadPdf: !this.state.isLoadingDownloadPdf })

                // const link = document.createElement('a');
                // link.href = `${process.env.REACT_APP_API_IMAGE_URL}${res.data.message}`;
                // link.setAttribute("target", '_blank');
                // document.body.appendChild(link);
                // link.click();
                // document.body.removeChild(link);

                this.downloadFile(`${process.env.REACT_APP_API_IMAGE_URL}${res.data.message}`);
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    componentDidMount = async () => {
        this.setState({ isLoading: true })
        const options = {
            params: {
                "Search": "",
            },
        };
        await this.fetchUserOrganization(options);

        await this.props.fetchProfileRequest();
    }

    fetchUserOrganization = async (options) => {
        await UserCreateApi.get('/user/getroleandorganization', options)
            .then((res) => {
                if (res.data.success) {
                    let organizations = res.data.liOrganizationResponse && res.data.liOrganizationResponse.map(organization => ({
                        'value': organization.nickName,
                        'label': organization.nickName
                    }));

                    this.setState({
                        organizations: organizations,
                    })
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    fetchUserReferal = async (refferalSearch) => {
        if (cancel !== undefined) {
            cancel();
        }
        let isMounted = true; // note this flag denote mount status
        let searchOrganization = this.state.organization && this.state.organization.map(function (item) { return item['value']; }).join();
        this.setState({ isLoadingReferral: true });
        let authToken = JSON.parse(localStorage.getItem("persist:userData")).authToken;
        var user = JSON.parse(JSON.parse(localStorage.getItem("persist:userData")).user);

        const options = {
            headers: { 'Content-Type': "application/json", 'AccessToken': `${authToken.replaceAll('"', '')}`, "UserId": `${user.userId}` },
            params: {
                "OrganizationParam": searchOrganization, // send selected organization StLukesHS,MPCS,MCMS,OHH,QMES
                "FacilityAddress": this.state.facilityAddress,
                "FacilityCity": this.state.facilityCity,
                "FacilityState": this.state.facilityState,
                "FacilityZip": this.state.facilityZip,
                "FacilityPhone": this.state.facilityPhone,
                "FacilityFax": this.state.facilityFax,
                "FacilityKey": this.state.facilityKey,
                "LimitParam": 100000,
                "OffsetParam": 0,
                "OrderByFieldParam": "",
                "SortOrderParam": "",
                "SearchParam": refferalSearch,
                "Id": "" // send selected refferal key
            },
            cancelToken: new CancelToken(function executor(c) {
                cancel = c;
            })
        }
        await axios.get(`${process.env.REACT_APP_API_URL}api/dashboard/getreferralsearchlist`, options)
            .then((res) => {
                let refData = '';
                if (res.data.success) {
                    refData = res.data.liGetReferralSearch && res.data.liGetReferralSearch.map(referral => ({
                        'value': referral.referralKey ? referral.referralKey : '',
                        'label': referral.referral ? referral.referral : '',
                        'referralType': referral.referralType ? referral.referralType : ''
                    }))
                }

                this.setState({
                    referralOptions: refData,
                    isLoadingReferral: false
                });
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    onSearchReferal = async () => {
        this.setState({ isLoadingReferral: true })
        const options = {
            params: {
                "OrganizationParam": this.state.searchOrganization,
                "FacilityAddress": this.state.facilityAddress,
                "FacilityCity": this.state.facilityCity,
                "FacilityState": this.state.facilityState,
                "FacilityZip": this.state.facilityZip,
                "FacilityPhone": this.state.facilityPhone,
                "FacilityFax": this.state.facilityFax,
                "FacilityKey": this.state.facilityKey,
                "LimitParam": 10,
                "OffsetParam": 0,
                "OrderByFieldParam": "",
                "SortOrderParam": "",
                "SearchParam": '',
                "Id": ""
            }
        }
        await UserCreateApi.get('dashboard/getreferralsearchlist', options)
            .then((res) => res.data.liGetReferralSearch && res.data.liGetReferralSearch.map(referral => ({
                'value': referral.referralKey,
                'label': referral.referral,
                'referralType': referral.referralType
            })))
            .then((referral) => referral && this.setState({
                referral,
                isLoadingReferral: false
            }))
    }

    handleSelectChange = (field, value, reason) => {
        if (field == 'referralSearch' && value && value.length >= 4) {
            this.fetchUserReferal(value);
        }
        else {
            this.setState({
                [field]: value
            })
        }
    }

    handleChange = (e) => {
        this.setState({ 'initialValues': { [e.target.name]: e.target.value } });
        this.setState({ [e.target.name]: e.target.value });
        this.setState({ 'auth': { [e.target.name]: e.target.value } });
    }
    handleChangeVlaue(field, value) {
        this.setState({ 'initialValues': { [field]: value } });
        this.setState({ [field]: value });
        this.setState({ 'auth': { [field]: value } });
    }
    handleImageClose = () => {
        this.setState({
            open: false
        });
    }

    handleImageSave(files) {
        //Saving files to state for further use and closing Modal.
        this.setState({
            files: files,
            open: false
        });
        this.props.saveProfileImage({
            files: files,
        });
    }

    handleImageOpen() {
        this.setState({
            open: true
        });
    }
    handleModalShowHide = () => {
        if (this.state.isShowFilter) {
            this.props.change('new_password', "");
            this.props.untouch('new_password');
            this.props.change('confirm_password', "");
            this.props.untouch('confirm_password');
        }
        this.setState({ isShowFilter: !this.state.isShowFilter })
    }
    onChange = (event) => {

        this.setState({ isError: false, error: '' })
        if (event.target.files.length > 0) {
            if (event.target.files[0].size / 1024 / 1024 > 5) {
                this.setState({ isError: true, error: 'image should be smaller than 5 MB' })
            }
            if (event.target.files && event.target.files[0]) {
                var type = event.target.files[0].type; // image/jpg, image/png, image/jpeg...

                // allow jpg, png, jpeg, bmp, gif, ico
                var type_reg = /^image\/(jpg|png|jpeg)$/;

                if (type.match(type_reg)) {
                    // file is ready to upload
                    this.getFiles.bind(this)
                } else {
                    this.setState({ isError: true, error: 'Only file with the .png, .jpeg, .jpg extension are allowed' })
                }
            }
            this.setState({
                avatar: event.target.files[0]
            });
        }
        else {
            this.setState({
                avatar: null
            });
        }
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.referralList && nextProps.referralList.length == 1) {
            this.setState({
                sleepScreenerLink: nextProps.referralList[0]['sleepScreenerLink'],
                referralKey: nextProps.referralList[0]['facilityName']
            });
        }
        if (nextProps.userDetails && nextProps.userDetails != this.props.userDetails) {
            let userDetails = nextProps.userDetails;
            if (userDetails.roleName == "super-admin" || userDetails.roleName == "adapthealth Admin") {
                this.setState({ isPortalSettingModuleVisible: true });
            }
            let referalSelectedOption = []
            let organizationSelectedOption = []

            if (userDetails.organization && userDetails.organization != '') {
                let userOrganization = userDetails.organization.split(',')
                organizationSelectedOption = this.state.organizations.filter((o) => {
                    return userOrganization.includes(o.value)
                })
            }

            const options = {
                params: {
                    "OrganizationParam": userDetails.organization,
                    "FacilityAddress": this.state.facilityAddress,
                    "FacilityCity": this.state.facilityCity,
                    "FacilityState": this.state.facilityState,
                    "FacilityZip": this.state.facilityZip,
                    "FacilityPhone": this.state.facilityPhone,
                    "FacilityFax": this.state.facilityFax,
                    "FacilityKey": this.state.facilityKey,
                    "LimitParam": 10,
                    "OffsetParam": 0,
                    "OrderByFieldParam": "",
                    "SortOrderParam": "",
                    "SearchParam": '',
                    "Id": userDetails.referral
                }
            }

            this.setState({
                organization: organizationSelectedOption,
            });

        }

        if (nextProps.referralList && this.props.userDetails) {

            if (this.props.userDetails) {
                let userDetails = this.props.userDetails;
                if (userDetails.roleName == "super-admin" || userDetails.roleName == "adapthealth Admin") {
                    this.setState({ isPortalSettingModuleVisible: true });
                }
                let referalSelectedOption = []
                let organizationSelectedOption = []

                if (userDetails.organization && userDetails.organization != '') {
                    let userOrganization = userDetails.organization.split(',')
                    organizationSelectedOption = this.state.organizations.filter((o) => {
                        return userOrganization.includes(o.value)
                    })
                }

                const options = {
                    params: {
                        "OrganizationParam": userDetails.organization,
                        "FacilityAddress": this.state.facilityAddress,
                        "FacilityCity": this.state.facilityCity,
                        "FacilityState": this.state.facilityState,
                        "FacilityZip": this.state.facilityZip,
                        "FacilityPhone": this.state.facilityPhone,
                        "FacilityFax": this.state.facilityFax,
                        "FacilityKey": this.state.facilityKey,
                        "LimitParam": 10,
                        "OffsetParam": 0,
                        "OrderByFieldParam": "",
                        "SortOrderParam": "",
                        "SearchParam": '',
                        "Id": userDetails.referral,
                        "RequestForGetUserDetails": userDetails.userId
                    }
                }
                if (userDetails.referral) {
                    UserCreateApi.get('dashboard/getreferralsearchlist', options)
                        .then((res) => res.data.liGetReferralSearch && res.data.liGetReferralSearch.map(referral => ({
                            'value': referral.referralKey,
                            'label': referral.referral,
                            'referralType': referral.referralType
                        })))
                        .then((referral) => referral && this.setState({
                            referral
                        }));
                }
            }
        }

        if (nextProps.saveProfileResponse) {
            if (nextProps.saveProfileResponse && nextProps.saveProfileResponse != this.props.saveProfileResponse) {
                if (nextProps.saveProfileResponse.success) {
                    this.setState({ isSaveProfile: false });
                    this.profileUpdateAlert(nextProps.saveProfileResponse.message, 'success');
                    this.props.fetchProfileRequest();
                }
                else {
                    this.setState({ isSaveProfile: false });
                    this.setState({ isSaveProfileFail: true });
                    this.profileUpdateAlert(nextProps.saveProfileResponse.message, 'failure');
                }
            }
        }

        this.setState({
            'auth': {
                name: nextProps.initialValues.name,
                title: nextProps.initialValues.title,
                role: nextProps.initialValues.role,
            },
        });
        if ((!window.$isProfileImage || window.$isProfileImage == false) && nextProps.initialValues.avatar !== undefined && nextProps.initialValues.avatar != null && nextProps.initialValues.avatar != "") {
            this.setState({
                imagePath: `${process.env.REACT_APP_API_IMAGE_URL}` + nextProps.initialValues.imagePath,
            });
            window.$isProfileImage = true
        }
        if ((!window.$isPapTypeUpdated || window.$isPapTypeUpdated == false) && nextProps.initialValues.papType != '') {
            this.setState({
                papType: nextProps.initialValues.papType,
            });
            window.$isPapTypeUpdated = true
        }
        if ((!window.$isPapUserUpdated || window.$isPapUserUpdated == false) && nextProps.initialValues.isPapUser != undefined) {
            this.setState({
                isPapUser: nextProps.initialValues.isPapUser,
            });
            window.$isPapUserUpdated = true
        }
        if (nextProps.loading != undefined)
            this.setState({ isLoading: nextProps.loading })
    }
    componentWillUnmount() {
        window.$isPapUserUpdated = false
        window.$isPapTypeUpdated = false
        window.$isProfileImage = false
    }
    onSubmit = async (formProps) => {
        if (formProps.new_password) {
            this.setState({ isChangePassword: true });
            var data = {
                "Password": formProps.new_password,
            };
            await UserCreateApi.post('user/changepassword', data)
                .then((res) => {
                    this.setState({ isChangePassword: false });
                    this.handleModalShowHide();
                    window.setTimeout(() => {
                        this.profileUpdateAlert(res.data.message, res.data.success ? 'success' : 'error');
                    }, 1000)
                });
        }
        else {
            if (this.validator.allValid()) {
                if (this.state.isPapUser !== null) {
                    let papType = '';

                    if (isChangedEvent === 0) {
                        papType = this.props.initialValues.papType;
                    }
                    if (this.state.airviewNameCheckbox == true && this.state.encoreNameCheckbox == true) {
                        papType = 'Both';
                    }
                    else if (this.state.airviewNameCheckbox == true) {
                        papType = 'AirView';
                    }
                    else if (this.state.encoreNameCheckbox == true) {
                        papType = 'Encore';
                    }
                    else {
                        papType = '';
                    }

                    if (papType == 'Both') {
                        if (formProps.airviewName == '' || formProps.airviewOrganizationName == '' || formProps.encoreName == '' || formProps.encoreSleepLab == '') {
                            this.profileUpdateError('Please enter PAP portal integration details', 'error');
                            if (formProps.airviewName == '') {
                                this.setState({ isErrorInAirView: true })
                            }
                            if (formProps.airviewOrganizationName == '') {
                                this.setState({ isErrorInOrganizationName: true })
                            }
                            if (formProps.encoreName == '') {
                                this.setState({ isErrorInEncoreView: true })
                            }
                            if (formProps.encoreSleepLab == '') {
                                this.setState({ isErrorInEncoreSleepLab: true })
                            }
                            return false;
                        }
                    }
                    else if (papType == 'AirView') {
                        if (formProps.airviewName == '' || formProps.airviewOrganizationName == '') {
                            this.profileUpdateError('Please enter PAP portal integration details', 'error');
                            if (formProps.airviewName == '') {
                                this.setState({ isErrorInAirView: true })
                            }
                            if (formProps.airviewOrganizationName == '') {
                                this.setState({ isErrorInOrganizationName: true })
                            }
                            return false;
                        }
                    }
                    else if (papType == 'Encore') {
                        if (formProps.encoreName == '' || formProps.encoreSleepLab == '') {
                            this.profileUpdateError('Please enter PAP portal integration details', 'error');
                            if (formProps.encoreName == '') {
                                this.setState({ isErrorInEncoreView: true })
                            }
                            if (formProps.encoreSleepLab == '') {
                                this.setState({ isErrorInEncoreSleepLab: true })
                            }
                            return false;
                        }
                    }
                    let organization = this.state.organization.map(function (item) { return item['value']; }).join()
                    let referral = this.state.referral.map(function (item) { return item['value']; }).join()
                    let referralType = this.state.referral.map(function (item) { return item['referralType']; }).join()

                    this.setState({ isSaveProfile: true });

                    var storedUserData = localStorage.getItem('persist:userData');
                    var parsedStoreUserData = JSON.parse(storedUserData);
                    parsedStoreUserData.referralParam = '"' + referral + '"';
                    parsedStoreUserData.organizationParam = '"' + organization + '"';

                    var user = JSON.parse(parsedStoreUserData.user);
                    user.globalSummaryAccess = parseInt(formProps.globalSummaryAccess);
                    user.sleepScreenerAccess = parseInt(formProps.sleepScreenerAccess);

                    parsedStoreUserData.user = JSON.stringify(user);

                    var newUserData = JSON.stringify(parsedStoreUserData);
                    localStorage.setItem("persist:userData", newUserData);

                    this.props.saveProfile({
                        statementType: formProps.new_password != undefined ? "update_with_password" : "update",
                        name: formProps.name,
                        title: formProps.title,
                        phone: formProps.phone,
                        password: formProps.new_password == undefined ? "" : formProps.new_password,
                        extension: formProps.extension,
                        // ImageData: this.is64baseimage == undefined ? "" : this.is64baseimage,
                        // CurrentImageName: this.isimageName == undefined ? "" : this.isimageName,
                        // IsDeleteImage: this.state.IsDelete,
                        isPapUser: parseInt(this.state.isPapUser),
                        papType: papType,
                        organizations: organization,
                        referrals: referral,
                        referralType:referralType,
                        airviewName: formProps.airviewName,
                        airviewOrganizationName: formProps.airviewOrganizationName,
                        encoreName: formProps.encoreName,
                        encoreSleepLab: formProps.encoreSleepLab,
                        NPI: formProps.NPI,
                        screenerEmailFrequency: formProps.screenerEmailFrequency,
                        globalSummaryAccess: formProps.globalSummaryAccess,
                        sleepScreenerAccess: formProps.sleepScreenerAccess
                    });
                }
            }
            else {
                this.validator.showMessages();
                this.forceUpdate();
            }
        }
    }

    handleChangePasswordFormSubmit = (event, formProps) => {
        event.preventDefault();
        // const formData={
        //     "firstLogin" : 1,
        // };

        var data = JSON.stringify({
            "Password": this.state.password,
        });

        UserCreateApi.post('user/changepassword', data)
            .then((res) => {
                alert('done');
            });
    }

    getFiles(files) {

        this.setState({ files: files })
        this.setState({ isError: false, error: '' })
        if (files.name.length > 0) {
            if (files.size.split(' ')[0] / 1024 > 5) {
                this.setState({ isError: true, error: 'image should be smaller than 5 MB' })
            }
            var type = files.name.split('.')[1] // image/jpg, image/png, image/jpeg...
            // allow jpg, png, jpeg, bmp, gif, ico
            var Extension = files.name.split('.')[1].toLowerCase();
            if (Extension == "gif" || Extension == "png" || Extension == "bmp" || Extension == "jpeg" || Extension == "jpg") {

                this.is64baseimage = files.base64.split(',')[1];
                this.isimageName = files.name.split('.')[1]
                this.setState({
                    imagePath: files.base64
                });
            }
            else {
                this.setState({ isError: true, error: 'Only file with the .gif, .png, .bmp, .jpeg, .jpg extension are allowed' })
            }

        }
        else {
            this.is64baseimage = null;
            this.isimageName = null;
        }
    }
    closeClick(IsDelete) {
        var allInputs = document.getElementsByTagName('input');
        for (var i = 0; i <= allInputs.length; i++) {
            if (allInputs[i] && allInputs[i].type && allInputs[i].type === 'file') {
                allInputs[i].value = allInputs[i].defaultValue;
            }
        }

        this.setState({
            imagePath: '',
            is64baseimage: null,
            isimageName: null
        });

        this.setState({ IsDelete: true });
        this.is64baseimage = null;
        this.isimageName = null;
        this.imagePath = '';
    }

    profileUpdateAlert(msg, type) {
        let getAlert = '';
        if (type == 'success') {
            getAlert = () => (
                <SweetAlert
                    success
                    title={msg}
                    onConfirm={() => this.hideAlert()}
                >
                </SweetAlert>
            );

        } else {
            getAlert = () => (
                <SweetAlert
                    error
                    title={msg}
                    onConfirm={() => this.hideAlert()}
                >
                </SweetAlert>
            );
        }

        this.setState({
            alert: getAlert(),
            showModal: !this.state.showModal,
        });
    }

    hideAlert() {
        this.setState({
            alert: null,
            showModal: !this.state.showModal,
        });
        if (this.state.isSaveProfileFail != true) {
            window.location.reload();
        }
        this.setState({ isSaveProfileFail: false });
    }

    hideErrorAlert() {
        this.setState({
            alert: null,
            showModal: !this.state.showModal,
        });
        this.setState({ isSaveProfileFail: false });
    }

    profileUpdateError(msg, type) {
        let getAlert = '';
        if (type == 'success') {
            getAlert = () => (
                <SweetAlert
                    success
                    title={msg}
                    onConfirm={() => this.hideErrorAlert()}
                >
                </SweetAlert>
            );

        } else {
            getAlert = () => (
                <SweetAlert
                    error
                    title={msg}
                    onConfirm={() => this.hideErrorAlert()}
                >
                </SweetAlert>
            );
        }

        this.setState({
            alert: getAlert(),
            showModal: !this.state.showModal,
        });
    }

    onShowAlert = () => {
        this.setState({ visible: true }, () => {
            window.setTimeout(() => {
                this.setState({ visible: false })
            }, 2000)
        });
    }

    handleAirtViewCheckbox = (e) => {
        var name = [e.target.name];
        if ([e.target.name] == 'airviewNameCheckbox') {
            this.setState({
                [e.target.name]: !this.state.airviewNameCheckbox
            });
        }
        else if ([e.target.name] == 'encoreNameCheckbox') {
            this.setState({
                [e.target.name]: !this.state.encoreNameCheckbox
            });
        }
        isChangedEvent = 1;
    }

    handleChangeEmailFrequency = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleChangeReferral = (e) => {
        this.setState({
            sleepScreenerLink: e.target.value,
            referralKey: e.target.selectedOptions[0].getAttribute('data-referralkey')
        });
    }

    airviewInfo() {
        const openPdfDocumentUrl = window.location.origin + '/pdfs/HelpDocumentForIdentifyOrganization.pdf';
        return (<OverlayTrigger
            placement="top"
            overlay={
                <BootstrapTooltip id={`tooltip-top`}>
                    <strong>Click for help finding this information</strong>
                </BootstrapTooltip>
            }
        ><a href={openPdfDocumentUrl} target="_blank"><FontAwesomeIcon icon={["fa", "info"]} style={{ fontSize: 'small', cursor: 'pointer', color: '#34bfa3' }} /></a></OverlayTrigger>)
    }

    showHideCareOrchestratorPhilipsInfoModal = () => {
        this.setState({ isShowCareOrchestratorPhilipsInfo: !this.state.isShowCareOrchestratorPhilipsInfo });
    }

    careOrchestratorPhilipsInfo = () => {
        const openPhilipUrl = window.location.origin + '/images/Philips.png';
        return (
            <>
                <OverlayTrigger
                    placement="top"
                    overlay={
                        <BootstrapTooltip id={`tooltip-top`}>
                            <strong>Click for help finding this information</strong>
                        </BootstrapTooltip>
                    }
                ><FontAwesomeIcon onClick={this.showHideCareOrchestratorPhilipsInfoModal} icon={["fa", "info"]} style={{ fontSize: 'small', cursor: 'pointer', color: '#34bfa3' }} />
                </OverlayTrigger>
                <Modal
                    className="sales-filters profile-change-pwd philips-modal-profile"
                    show={this.state.isShowCareOrchestratorPhilipsInfo}
                    onHide={this.showHideCareOrchestratorPhilipsInfoModal}
                    backdrop="static"
                    keyboard={false}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"

                >
                    <Modal.Header closeButton>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="form-group text-center">
                            <div className="col-sm-12 philip-img">
                                <img src={openPhilipUrl} />
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={this.showHideCareOrchestratorPhilipsInfoModal} className={`btn btn-secondary close-filter-popup ml-auto phillips-modal-btn`}> Cancel</Button>
                    </Modal.Footer>
                </Modal>
            </>
        )
    }

    handleClose = () => {
        this.setState({ openModel: false })
    }
    handleOpenModel = () => {
        this.setState({ openModel: true })
    }

    onClickReset = () => {
        this.setState({
            facilityAddress: '',
            facilityCity: '',
            facilityState: '',
            facilityZip: '',
            facilityPhone: '',
            facilityFax: '',
            facilityKey: '',
        })
    }

    render() {
        var globalSummaryAccessOptions = [
            { value: 1, lable: 'Yes' },
            { value: 0, lable: 'No' },
        ]

        var sleepScreenerAccessOptions = [
            { value: 0, lable: 'None' },
            { value: 1, lable: 'View Only' },
            { value: 2, lable: 'View and Edit' },
        ]

        const { isimagePathLoading } = this.props;
        const refLinks = this.props.referralList;
        const spinner = <span className="loader"></span>;
        const { handleSubmit, pristine, reset, submitting, formValues, change } = this.props;
        let papTypeOptions = [{ value: "", lable: 'Please select option' },
        { lable: "AirView", value: 'AirView' },
        { lable: "Encore", value: 'Encore' },
        { lable: "Both", value: 'Both' }]
        const { loading } = this.props;

        isLoadFirstTime++;
        let airviewNameCheckboxDefaultChecked = false;
        let encoreNameCheckboxDefaultChecked = false;
        if (isLoadFirstTime === 4) {
            if (this.props.initialValues.papType == 'Both') {
                airviewNameCheckboxDefaultChecked = true;
                encoreNameCheckboxDefaultChecked = true;
                this.setState({
                    airviewNameCheckbox: !this.state.airviewNameCheckbox,
                    encoreNameCheckbox: !this.state.encoreNameCheckbox,
                });
            }
            else if (this.props.initialValues.papType == 'AirView') {
                airviewNameCheckboxDefaultChecked = true;
                encoreNameCheckboxDefaultChecked = false;
                this.setState({
                    airviewNameCheckbox: !this.state.airviewNameCheckbox
                });
            }
            else if (this.props.initialValues.papType == 'Encore') {
                encoreNameCheckboxDefaultChecked = true;
                airviewNameCheckboxDefaultChecked = false;
                this.setState({
                    encoreNameCheckbox: !this.state.encoreNameCheckbox,
                });
            }
            isLoadFirstTime = 5;
        }

        else if (this.state.airviewNameCheckbox == 'true' && this.state.encoreNameCheckbox == 'true') {
            airviewNameCheckboxDefaultChecked = true;
            encoreNameCheckboxDefaultChecked = true;
        }
        else if (this.state.airviewNameCheckbox == 'true') {
            airviewNameCheckboxDefaultChecked = true;
        }
        else if (this.state.encoreNameCheckbox == 'true') {
            encoreNameCheckboxDefaultChecked = true;
        }

        if (airviewNameCheckboxDefaultChecked) {
            if (document.getElementById('airviewNameCheckbox'))
                document.getElementById('airviewNameCheckbox').checked = true;
        }
        if (encoreNameCheckboxDefaultChecked) {
            if (document.getElementById('encoreNameCheckbox'))
                document.getElementById('encoreNameCheckbox').checked = true;
        }

        return (
            <>
                <Helmet>
                    <title>Profile | Scorecard</title>
                </Helmet>
                <div className="main-content-body">
                    {this.state.alert}
                    <div className="container-fluid">
                        {/* {
                            this.state.showModal ? (
                                <Modal>
                                    {this.state.alert}
                                </Modal>
                            ) : null
                        } */}
                        <div className="row">
                            <div className="col-lg-3  left-side-bar">
                                <MenuLeftNav isExpand={{ expand: "panel1", active: "dashboard" }}></MenuLeftNav>
                            </div>
                            <div className="col-lg-9 right-content-wrap mt-4  mb-5">
                                {/* shadow p-3 mb-5 bg-white rounded   shadow-sm p-3 mb-5 bg-white rounded*/}
                                <div className="order-and-adherence-detail Profile-update-title py-3 mb-5 bg-white rounded profile-box">
                                    <div >
                                        <p className="main-heading" style={{ fontWeight: '600', fontSize: 'large', color: '#6b6969' }}>Update Profile</p>
                                    </div>

                                    <Divider />
                                    <div className="mt-5">
                                        <Loader show={loading | this.state.isLoadingDownloadPdf} message={spinner}>
                                            <form className="form-horizontal" onSubmit={handleSubmit(this.onSubmit)}>
                                                <div className="profile-box-shadow">
                                                    <p className="main-heading" style={{ fontWeight: '600', fontSize: 'large', color: '#6b6969' }}>Personal Information</p>
                                                    <div className="row">
                                                        <div className="form-group nameField col-lg-6">
                                                            <label >Name<span className="text-danger"> *</span></label>
                                                            <Field
                                                                type="text"
                                                                margin="normal"
                                                                name="name"
                                                                placeholder="Please enter your name"
                                                                component={renderField}
                                                            // isAsterisk="true"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row"
                                                        style={{ marginTop: this.state.imagePath != "" && this.state.imagePath != null ? '-8%' : '0%' }}>
                                                        <div className="form-group titleField col-lg-6">
                                                            <label >Title<span className="text-danger"> *</span></label>
                                                            <Field
                                                                type="text"
                                                                margin="normal"
                                                                name="title"
                                                                // label="Title"
                                                                placeholder="Please enter your title"
                                                                component={renderField}
                                                            // isAsterisk="true"
                                                            />
                                                        </div>

                                                        {/* <label className="custom-label col-sm-2 text-right" style={{ color: "#000", marginTop: 7, fontWeight: 400 }}>Add Photo</label>
                                                     */}
                                                    </div>

                                                    <div className="form-group roleField col-lg-6">
                                                        <label >Portal Role</label>
                                                        <Field
                                                            type="text"
                                                            margin="normal"
                                                            name="role"
                                                            // label="Role"
                                                            isReadOnly="true"
                                                            placeholder="Please enter your role"
                                                            component={renderField}
                                                        />
                                                    </div>
                                                    <div className="row">
                                                        <div className="form-group NPIField col-lg-6">
                                                            <label >Provider NPI</label>
                                                            <Field
                                                                type="text"
                                                                margin="normal"
                                                                name="NPI"
                                                                label="NPI"
                                                                max="25"
                                                                placeholder="Optional"
                                                                component={renderField}
                                                                normalize={val => (val || "").replace(/[^\d]/g, "")}
                                                            />
                                                        </div>
                                                        <div className="form-group mt-5 col-lg-5">
                                                            <button type="button" className={`btn btn-primary`} aria-controls="simple-menu" aria-haspopup="true"
                                                                onClick={this.handleModalShowHide}> Change Password </button>
                                                            <Modal
                                                                className="sales-filters profile-change-pwd"
                                                                show={this.state.isShowFilter}
                                                                onHide={this.handleModalShowHide}
                                                                backdrop="static"
                                                                keyboard={false}
                                                                size="lg"
                                                                aria-labelledby="contained-modal-title-vcenter"

                                                            >
                                                                <Modal.Header closeButton>
                                                                    <Modal.Title> <span
                                                                        className="ml-1 mr-4"><b>Update Password</b></span>
                                                                    </Modal.Title>
                                                                </Modal.Header>
                                                                <form className="form-horizontal" onSubmit={handleSubmit(this.onSubmit)}>
                                                                    <Modal.Body>
                                                                        <div className="form-group">
                                                                            <div className="form-group passwordField col-lg-12">
                                                                                <label >New Password</label>
                                                                                <Field
                                                                                    type="password"
                                                                                    margin="normal"
                                                                                    name="new_password"

                                                                                    placeholder="Please enter new password"
                                                                                    component={renderChangePasswordField}
                                                                                />
                                                                            </div>
                                                                            <div className="form-group confirmpasswordField col-lg-12">
                                                                                <label >Confirm Password</label>
                                                                                <Field
                                                                                    type="password"
                                                                                    margin="normal"
                                                                                    name="confirm_password"
                                                                                    // label="Confirm Password"
                                                                                    placeholder="Please enter confirm password"
                                                                                    component={renderChangePasswordField}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </Modal.Body>
                                                                    <Modal.Footer>
                                                                        <Button type="submit"
                                                                            className={`btn btn-primary apply-filter ${clsx(
                                                                                {
                                                                                    "kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light": this.state.isChangePassword
                                                                                }
                                                                            )}`}
                                                                        >Update Password</Button>
                                                                        <Button onClick={this.handleModalShowHide} className={`btn btn-secondary close-filter-popup`}> Cancel</Button>
                                                                    </Modal.Footer>
                                                                </form>
                                                            </Modal>
                                                        </div>
                                                    </div>
                                                </div>


                                                <div className=" mt-5 profile-box-shadow">
                                                    <p className="main-heading" style={{ fontWeight: '600', fontSize: 'large', color: '#6b6969' }}>Contact Information</p>
                                                    <div className="row">
                                                        <div className="form-group emailField col-lg-4">
                                                            <label >Email</label>
                                                            <Field
                                                                type="text"
                                                                margin="normal"
                                                                name="email"
                                                                isReadOnly="true"
                                                                placeholder="Please enter your email"
                                                                component={renderField}
                                                            />
                                                        </div>
                                                        <div className="form-group phoneField col-lg-4">
                                                            <label >Phone</label>
                                                            <Field
                                                                type="text"
                                                                margin="normal"
                                                                name="phone"
                                                                placeholder="Optional"
                                                                component={renderField}
                                                                normalize={val => (val || "").replace(/[^\d]/g, "")}
                                                            />
                                                        </div>

                                                        <div className="form-group extensionField col-lg-4">
                                                            <label >Extension</label>
                                                            <Field
                                                                type="text"
                                                                margin="normal"
                                                                name="extension"
                                                                autoComplete="new-off"
                                                                placeholder="Optional"
                                                                component={renderField}
                                                                normalize={val => (val || "").replace(/[^\d]/g, "")}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className=" mt-5 profile-box-shadow notification">
                                                    <p className="main-heading" style={{ fontWeight: '600', fontSize: 'large', color: '#6b6969' }}>Notifications</p>
                                                    <div className="form-group">
                                                        <label >Sleep Screener Results</label>
                                                        <Field
                                                            type="select"
                                                            margin="normal"
                                                            name="screenerEmailFrequency"
                                                            // label="screenerEmailFrequency"
                                                            component={renderSelectField}
                                                            options={emailFrequencyOptions}
                                                            selectedOption={this.props.initialValues.screenerEmailFrequency} />
                                                    </div>
                                                    {/* <div className="row">
                                                        <div className="form-group emailField col-lg-4">
                                                            <label >Sleep Screener Results</label>
                                                            <div className="formgroup">
                                                                <div className="row">
                                                                    <select id="screenerEmailFrequency" name="screenerEmailFrequency" className="form-control" onChange={this.handleChangeEmailFrequency}>
                                                                        <option value="0">Please Select</option>
                                                                        <option value="Instant">Immediately</option>
                                                                        <option value="Day">Once a day</option>
                                                                        <option value="Week">Once a week</option>
                                                                        <option value="Never">Never</option>
                                                                    </select>
                                                                    
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div> */}
                                                </div>
                                                {
                                                    this.state.isPortalSettingModuleVisible &&
                                                    <div className=" mt-5 profile-box-shadow notification" >
                                                        <p className="main-heading" style={{ fontWeight: '600', fontSize: 'large', color: '#6b6969' }}>Portal Settings</p>
                                                        <div>
                                                            <div className="form-group ">
                                                                <div className="formgroup">
                                                                    <div className="mt-3">
                                                                        <label className="custom-label " style={{ color: "#646c9a", marginTop: 7 }}>Default View<span className="text-danger"> *</span></label>

                                                                        <div className="col-sm-9 is-pap-switch">
                                                                            <ToggleButtonGroup value={this.state.isPapUser} exclusive onChange={(event, view) => { this.handleChangeVlaue('isPapUser', view) }}>
                                                                                <ToggleButton className="active" value={1} aria-label="PAP" selected={this.state.isPapUser == 1}> PAP </ToggleButton>
                                                                                <ToggleButton value={0} className="active" aria-label="NON-PAP" selected={this.state.isPapUser == 0} >NON-PAP</ToggleButton>
                                                                            </ToggleButtonGroup>
                                                                        </div>
                                                                        {this.state.isPapUser === null && <span class="error-msg text-danger toggle-btn-error-msg">This field is required</span>}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {/* <Field
                                                                type="select"
                                                                margin="normal"
                                                                name="papType"
                                                                label="Which PAP Portal do you use?"
                                                                onChange={this.handleChange}
                                                                //isAsterisk="true"
                                                                component={renderField}
                                                                options={papTypeOptions}
                                                            /> */}
                                                        </div>

                                                        <div className="form-group">
                                                            <label >Global Summary Access</label>
                                                            <Field
                                                                type="select"
                                                                margin="normal"
                                                                name="globalSummaryAccess"
                                                                // label="screenerEmailFrequency"
                                                                component={renderSelectField}
                                                                options={globalSummaryAccessOptions}
                                                                selectedOption={this.props.initialValues.globalSummaryAccess}
                                                            />
                                                        </div>
                                                        <div className="form-group">
                                                            <label >Sleep Screener Access</label>
                                                            <Field
                                                                type="select"
                                                                margin="normal"
                                                                name="sleepScreenerAccess"
                                                                // label="screenerEmailFrequency"
                                                                component={renderSelectField}
                                                                options={sleepScreenerAccessOptions}
                                                                selectedOption={this.props.initialValues.sleepScreenerAccess}
                                                            />
                                                        </div>
                                                        {this.state.isPapUser == 1 && <div >
                                                            <p className="main-heading" style={{ fontWeight: '600', fontSize: '16px', color: '#6b6969' }}>PAP Portal Integration</p>
                                                            <p className="main-heading" style={{ fontWeight: '600', fontSize: '14px', color: '#6b6969' }}>Which PAP portal(s) do you use ? Select and provide integration details.</p>

                                                            <p className="main-heading info-heading mt-3" style={{ fontWeight: '600', fontSize: '16px', color: '#6b6969' }}>
                                                                <label className="airviewLabel" htmlFor="airviewNameCheckbox">
                                                                    {airviewNameCheckboxDefaultChecked ?
                                                                        <input id="airviewNameCheckbox" name="airviewNameCheckbox" type="checkbox" className="profile-check-box" value={this.state.airviewNameCheckbox} onClick={this.handleAirtViewCheckbox} />
                                                                        : <input id="airviewNameCheckbox" name="airviewNameCheckbox" type="checkbox" className="profile-check-box" value={this.state.airviewNameCheckbox} onChange={this.handleAirtViewCheckbox} />}
                                                                &nbsp; Airview (ResMed)</label>{this.airviewInfo()}</p>

                                                            <div className="row ml-4">
                                                                <div className={`form-group airviewField col-lg-6 ${clsx(
                                                                    {
                                                                        "airview-red-border-error": this.state.isErrorInAirView
                                                                    }
                                                                )}`}>
                                                                    <label >Airview Name</label>
                                                                    <Field
                                                                        type="text"
                                                                        margin="normal"
                                                                        name="airviewName"
                                                                        // label="Airview"
                                                                        placeholder="Optional"
                                                                        component={renderField}
                                                                        disabled={this.state.airviewNameCheckbox ? false : true}
                                                                    />
                                                                </div>
                                                                <div className={`form-group organizationNameField col-lg-6 ${clsx(
                                                                    {
                                                                        "airview-red-border-error": this.state.isErrorInOrganizationName
                                                                    }
                                                                )}`}>
                                                                    <label >Organization Name</label>
                                                                    <Field
                                                                        type="text"
                                                                        margin="normal"
                                                                        name="airviewOrganizationName"
                                                                        // label="Organization Name"
                                                                        placeholder="Optional"
                                                                        component={renderField}
                                                                        disabled={this.state.airviewNameCheckbox ? false : true}
                                                                    />
                                                                </div>
                                                            </div>

                                                            <p className="main-heading info-heading" style={{ fontWeight: '600', fontSize: '16px', color: '#6b6969' }}>
                                                                <label className="airviewLabel" htmlFor="encoreNameCheckbox">
                                                                    {encoreNameCheckboxDefaultChecked ?
                                                                        <input id="encoreNameCheckbox" name="encoreNameCheckbox" type="checkbox" className="profile-check-box" value={this.state.encoreNameCheckbox} onChange={this.handleAirtViewCheckbox} />
                                                                        : <input id="encoreNameCheckbox" name="encoreNameCheckbox" type="checkbox" className="profile-check-box" value={this.state.encoreNameCheckbox} onChange={this.handleAirtViewCheckbox} />}
                                                                    &nbsp; Care Orchestrator (Philips)</label>{this.careOrchestratorPhilipsInfo()}</p>
                                                            <div className="row ml-4">
                                                                <div className={`form-group airviewField col-lg-6 ${clsx(
                                                                    {
                                                                        "airview-red-border-error": this.state.isErrorInEncoreView
                                                                    }
                                                                )}`}>
                                                                    <label >Name</label>
                                                                    <Field
                                                                        type="text"
                                                                        margin="normal"
                                                                        name="encoreName"
                                                                        // label="Airview"
                                                                        placeholder="Optional"
                                                                        component={renderField}
                                                                        disabled={this.state.encoreNameCheckbox ? false : true}
                                                                    />
                                                                </div>
                                                                <div className={`form-group organizationNameField col-lg-6 ${clsx(
                                                                    {
                                                                        "airview-red-border-error": this.state.isErrorInEncoreSleepLab
                                                                    }
                                                                )}`}>
                                                                    <label >Sleep Lab</label>
                                                                    <Field
                                                                        type="text"
                                                                        margin="normal"
                                                                        name="encoreSleepLab"
                                                                        // label="Organization Name"
                                                                        placeholder="Optional"
                                                                        component={renderField}
                                                                        disabled={this.state.encoreNameCheckbox ? false : true}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        }

                                                        {/* <div className="form-group passwordField">
                                                        <Field
                                                            type="password"
                                                            margin="normal"
                                                            name="new_password"
                                                            label="New Password"
                                                            autoComplete="new-password"
                                                            placeholder="Please enter new password"
                                                            component={renderField}
                                                        />
                                                        </div>
                                                        <div className="form-group confirmpasswordField">
                                                            <Field
                                                                type="password"
                                                                margin="normal"
                                                                name="confirm_password"
                                                            label="Confirm Password"
                                                                placeholder="Please  Confirm password"
                                                                component={renderField}
                                                            />
                                                        </div> */}
                                                        {this.props.initialValues.roleId === 1 &&
                                                            <>
                                                                <div className="col-lg-9 form-group">
                                                                    <label >Organization <sup className="text-danger"> *</sup></label>
                                                                    <Autocomplete
                                                                        name="organization"
                                                                        id="tags-standard"
                                                                        getOptionLabel={(option) => option.label}
                                                                        options={this.state.organizations || []}
                                                                        renderInput={(params) => (
                                                                            <TextField
                                                                                {...params}
                                                                                variant="outlined"
                                                                                InputProps={{
                                                                                    ...params.InputProps,
                                                                                    endAdornment: (
                                                                                        <React.Fragment>

                                                                                            {params.InputProps.endAdornment}
                                                                                        </React.Fragment>
                                                                                    ),
                                                                                }}
                                                                            />
                                                                        )}
                                                                        value={this.state.organization}
                                                                        onChange={(e, value, reason) => this.handleSelectChange('organization', value, reason)}
                                                                        multiple
                                                                        onClick={() => this.validator.showMessageFor('organization')}
                                                                    />
                                                                    {this.validator.message('organization', this.state.organization, 'required', { className: 'text-danger' })}
                                                                </div>
                                                                <div className="col-lg-9  form-group">
                                                                    <label >Referral <sup className="text-danger"> *</sup></label>
                                                                    <div className={`multiselect ${clsx(
                                                                        {
                                                                            "profile-refferal-loader": this.state.isLoadingReferral
                                                                        }
                                                                    )}`}>
                                                                        <Autocomplete
                                                                            multiple
                                                                            name="referrral"
                                                                            id="tags-standard5"
                                                                            loading={this.state.isLoadingReferral}
                                                                            getOptionLabel={(option) => option.label}
                                                                            getOptionSelected={(option) => option == this.state.referralOptions}
                                                                            options={this.state.referralOptions || []}
                                                                            renderInput={(params) => (
                                                                                <TextField
                                                                                    {...params}
                                                                                    variant="outlined"
                                                                                    placeholder="Enter at least 4 character"
                                                                                    InputProps={{
                                                                                        ...params.InputProps,
                                                                                        endAdornment: (
                                                                                            <React.Fragment>

                                                                                                {params.InputProps.endAdornment}
                                                                                            </React.Fragment>
                                                                                        ),
                                                                                    }}

                                                                                />
                                                                            )}
                                                                            value={this.state.referral}
                                                                            onChange={(e, value, reason) => this.handleSelectChange('referral', value, reason)}
                                                                            onInputChange={(e, value, reason) => this.handleSelectChange('referralSearch', value, reason)}
                                                                            onClick={() => this.validator.showMessageFor('referral')}
                                                                        />
                                                                    </div>
                                                                    {this.validator.message('referral', this.state.referral, 'required', { className: 'text-danger' })}
                                                                </div>
                                                                <div className="form-group">
                                                                    <div className="col-lg-6 text-left">
                                                                        <button
                                                                            onClick={this.handleOpenModel}
                                                                            type="button"
                                                                            className={`btn btn-primary btn-elevate font-weight-bold`}>
                                                                            ADVANCE SEARCH
                                                                                </button>
                                                                        {(this.state.facilityAddress || this.state.facilityCity || this.state.facilityState || this.state.facilityZip || this.state.facilityPhone || this.state.facilityFax || this.state.facilityKey) &&
                                                                            <button
                                                                                type="reset" onClick={this.onClickReset}
                                                                                type="button"
                                                                                className={`border btn btn-white btn-elevate font-weight-bold ml-2`}>
                                                                                Reset
                                                                                </button>}
                                                                    </div>
                                                                </div>
                                                            </>
                                                        }
                                                    </div>
                                                }
                                                {refLinks && refLinks.length > 0 &&
                                                    <div className=" mt-5 profile-box-shadow notification">
                                                        {this.state.visible && <Fade in={this.state.visible}>
                                                            <div id="example-fade-text" className="alert-info copy-link-alert">
                                                                Copied sleep screener link
                                                        </div>
                                                        </Fade>}
                                                        <p className="main-heading" style={{ fontWeight: '600', fontSize: 'large', color: '#6b6969' }}>Sleep Screener</p>
                                                        <div className="formgroup">
                                                            <div className="row">
                                                                <div class="col-sm-8 col-lg-8 col-xl-6 select-referral">
                                                                    <label style={{ color: "##646c9a", marginTop: 7 }}>Referral</label>
                                                                    <select id="selectReferral" name="selectReferral" className="form-control" onChange={this.handleChangeReferral}>
                                                                        <option value=''>Please select</option>
                                                                        {refLinks && refLinks.map((refLink, index) => {
                                                                            if (this.state.sleepScreenerLink == refLink.sleepScreenerLink) {
                                                                                return <option selected="selected" data-referralkey={refLink.facilityName} value={refLink.sleepScreenerLink}>{refLink.facilityName}</option>
                                                                            }
                                                                            else {
                                                                                return <option data-referralkey={refLink.facilityName} value={refLink.sleepScreenerLink}>{refLink.facilityName}</option>
                                                                            }
                                                                        })}
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {this.state.sleepScreenerLink && <>
                                                            <div className="formgroup mt-4">
                                                                <div className="row">
                                                                    <div class="col-sm-12">
                                                                        <label className="min-width" style={{ color: "rgb(120 121 130)", marginTop: 7 }}>Screener Link</label>
                                                                        <a href={this.state.sleepScreenerLink} target="_blank">{this.state.sleepScreenerLink}</a>
                                                                        <CopyToClipboard className="ml-3" text={this.state.sleepScreenerLink}
                                                                            onCopy={() => this.onShowAlert()}><FontAwesomeIcon icon={["fa", "copy"]} style={{ fontSize: 'large', cursor: 'pointer', color: '#34bfa3' }} /></CopyToClipboard>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="formgroup mt-4">
                                                                <div className="row">
                                                                    <div class="col-sm-6">
                                                                        <label className="min-width" style={{ color: "rgb(120 121 130)", marginTop: 7 }}>Flyer</label>
                                                                        <a href="javascript:void(0);" onClick={this.downloadPDF}>Download Flyer for {this.state.referralKey}</a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="formgroup mt-4">
                                                                <div className="row">
                                                                    <div class="col-sm-6 qr-code-wrap">
                                                                        <label className="min-width" style={{ color: "rgb(120 121 130)", marginTop: 7 }}>QR Code</label>
                                                                        <QRCode
                                                                            id={this.state.referralKey}
                                                                            value={this.state.sleepScreenerLink}
                                                                            size={100}
                                                                            level={"H"}
                                                                            includeMargin={true}
                                                                            onClick={(e) => this.handleQrModalShowHide(0, this.state.sleepScreenerLink, this.state.referralKey)}
                                                                            style={{ cursor: 'pointer' }}
                                                                        />
                                                                        <QRCode
                                                                            id={"big" + this.state.referralKey}
                                                                            value={this.state.sleepScreenerLink}
                                                                            size={400}
                                                                            level={"H"}
                                                                            includeMargin={true}
                                                                            onClick={(e) => this.handleQrModalShowHide(0, this.state.sleepScreenerLink, this.state.referralKey)}
                                                                            style={{ display: 'none' }}
                                                                        />
                                                                        <a type="button" onClick={this.downloadQR} className={`copy-qr-code apply-filter`}>Download QR</a>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <Modal
                                                                className="sales-filters profile-change-pwd qr-code-modal"
                                                                show={this.state.isShowQrModal}
                                                                onHide={(e) => this.handleQrModalShowHide(0, this.state.sleepScreenerLink, this.state.referralKey)}
                                                                backdrop="static"
                                                                keyboard={false}
                                                                size="lg"
                                                                aria-labelledby="contained-modal-title-vcenter"

                                                            >
                                                                <Modal.Header closeButton>
                                                                    <Modal.Title> <span
                                                                        className="ml-1 mr-4"><b>{this.state.referralKey} - QR Code</b></span>
                                                                    </Modal.Title>
                                                                </Modal.Header>
                                                                <Modal.Body>
                                                                    <div className="form-group text-center">
                                                                        <div className="col-sm-12 qr-code-img">
                                                                            <QRCode
                                                                                id={this.state.referralKey}
                                                                                value={this.state.sleepScreenerLink}
                                                                                size={400}
                                                                                level={"H"}
                                                                                includeMargin={true}
                                                                            />
                                                                        </div>
                                                                        <div className="col-sm-12">
                                                                            <a type="button" onClick={this.downloadQR} className={`btn btn-primary apply-filter`}>Download QR</a>
                                                                            <Button onClick={(e) => this.handleQrModalShowHide(0, this.state.sleepScreenerLink, this.state.referralKey)} className={`btn btn-secondary close-filter-popup`}> Cancel</Button>
                                                                        </div>
                                                                    </div>
                                                                </Modal.Body>
                                                            </Modal>
                                                        </>}
                                                    </div>
                                                }
                                                <Divider style={{ marginTop: 30 }} />
                                                <div className="row mt-3 mb-3"  >
                                                    <div className="col-sm-2 mt-3 text-right"></div>
                                                    <div className="col-sm-9 text-center userprofile-btn">
                                                        <button style={{ width: 120 }}
                                                            id="kt_login_signin_submit"
                                                            type="submit"
                                                            disabled={submitting || this.state.isError}
                                                            className={`btn btn-primary btn-elevate kt-login__btn-primary button-big mr-2 ${clsx(
                                                                {
                                                                    "kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light": this.state.isSaveProfile
                                                                }
                                                            )}`}
                                                        >
                                                            Submit
                                                    </button>
                                                        <Link style={{ width: 120 }}
                                                            to="/dashboard"
                                                            className={`btn btn-default btn-no`}>
                                                            Cancel
                                                    </Link>
                                                    </div>

                                                </div>
                                            </form>
                                        </Loader>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <Dialog className="user-model" onClose={this.handleClose} aria-labelledby="customized-dialog-title" open={this.state.openModel}>
                    <DialogTitle id="customized-dialog-title" onClose={this.handleClose}>
                        <FontAwesomeIcon icon={["fas", "filter"]} size='lg' />
                            Filter
                        </DialogTitle>
                    <DialogContent dividers>
                        <div className="modal-form-filter">
                            <div className="row">
                                <div className="col-md-4">
                                    <form className="filter-form" autoComplete="off">
                                        <FormLabel className="">
                                            Facility Address
                                            </FormLabel>
                                        <Input className="" name="facilityAddress" type="text" placeholder="Facility Address" value={this.state.facilityAddress} onChange={(e) => this.setState({ facilityAddress: e.target.value })} />

                                        <FormLabel className="">
                                            Facility Zip
                                            </FormLabel>
                                        <Input className="" name="facilityZip" type="text" placeholder="Facility Zip" value={this.state.facilityZip} onChange={(e) => this.setState({ facilityZip: e.target.value })} />

                                        <FormLabel className="">
                                            Facility Key
                                            </FormLabel>
                                        <Input className="" name="facilityKey" type="text" placeholder="Facility Key" value={this.state.facilityKey} onChange={(e) => this.setState({ facilityKey: e.target.value })} />

                                    </form>

                                </div>

                                <div className="col-md-4">
                                    <form className="filter-form" autoComplete="off">
                                        <FormLabel className="">
                                            Facility City
                                            </FormLabel>
                                        <Input className="" name="facilityCity" type="text" placeholder="Facility City" value={this.state.facilityCity} onChange={(e) => this.setState({ facilityCity: e.target.value })} />

                                        <FormLabel className="">
                                            Facility Phone
                                            </FormLabel>
                                        <Input className="" name="facilityPhone" type="text" placeholder="Facility Phone" value={this.state.facilityPhone} onChange={(e) => this.setState({ facilityPhone: e.target.value })} />
                                    </form>
                                </div>


                                <div className="col-md-4">
                                    <form className="filter-form" autoComplete="off">
                                        <FormLabel className="">
                                            Facility State
                                            </FormLabel>
                                        <Input className="" name="facilityState" type="text" placeholder="Facility State" value={this.state.facilityState} onChange={(e) => this.setState({ facilityState: e.target.value })} />

                                        <FormLabel className="">
                                            Facility FAX
                                            </FormLabel>
                                        <Input className="" name="facilityFax" type="text" placeholder="Facility Fax" value={this.state.facilityFax} onChange={(e) => this.setState({ facilityFax: e.target.value })} />
                                    </form>
                                </div>
                            </div>
                        </div>
                    </DialogContent>
                    <DialogActions>

                        <div className="modal-btns">
                            <Button autoFocus onClick={this.handleClose} type="button" className="btn btn-primary set-search-btn">Set Search Criteria
                                </Button>
                            <Button type="reset" onClick={this.onClickReset} className="btn btn-secondary reset-search-criteria">Reset</Button>
                            <Button type="button" onClick={this.handleClose} className="btn btn-secondary reset-close-criteria">close</Button>

                        </div>
                    </DialogActions>
                </Dialog>
            </>
        );
    }
}

profile.defaultProps = {
    isimagePathLoading: false
}
profile = reduxForm({
    form: 'profile',
    validate,
    asyncValidate,
    enableReinitialize: true,
    destroyOnUnmount: false
})(profile);

function mapStateToProps(state, props) {
    return {
        userData: state.auth.userData,
        profile: state.Profile,
        isPapUser: state.auth.user.isPapUser,
        userDetails: state.auth.userDetails,
        initialValues: {
            name: state.auth.name,
            title: state.auth.title,
            role: state.auth.role,
            roleId: state.auth.roleId,
            email: state.auth.email,
            phone: state.auth.phone,
            extension: state.auth.extension,
            imagePath: state.auth.imagePath,
            isPapUser: state.auth.isPapUser ? state.auth.isPapUser : '',
            papType: state.auth.papType ? state.auth.papType : '',
            airviewName: state.auth.airviewName,
            airviewOrganizationName: state.auth.airviewOrganizationName,
            encoreName: state.auth.encoreName,
            encoreSleepLab: state.auth.encoreSleepLab,
            isPapUser: state.auth.isPapUser,
            avatar: state.auth.avatar,
            NPI: state.auth.npi,
            screenerEmailFrequency: state.auth.screenerEmailFrequency,
            globalSummaryAccess: state.auth.globalSummaryAccess ? state.auth.globalSummaryAccess : 0,
            sleepScreenerAccess: state.auth.sleepScreenerAccess ? state.auth.sleepScreenerAccess : 0,
        },
        loading: state.auth.loading,
        saveProfileResponse: state.auth.saveProfileResponse,
        referralList: state.auth.referralList

    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        fetchProfileRequest: () => dispatch(auth.actions.fetchProfileRequest()),
        saveProfile: ({
            statementType,
            name,
            title,
            phone,
            password,
            extension,
            ImageData,
            CurrentImageName,
            IsDeleteImage,
            isPapUser,
            papType,
            airviewName,
            airviewOrganizationName,
            encoreName,
            encoreSleepLab,
            NPI,
            screenerEmailFrequency,
            globalSummaryAccess,
            organizations,
            referrals,
            referralType,
            sleepScreenerAccess,

        }) => dispatch(auth.actions.saveProfile({
            statementType,
            name,
            title,
            phone,
            password,
            extension,
            ImageData,
            CurrentImageName,
            IsDeleteImage,
            isPapUser,
            papType,
            airviewName,
            airviewOrganizationName,
            encoreName,
            encoreSleepLab,
            NPI,
            screenerEmailFrequency,
            globalSummaryAccess,
            organizations,
            referrals,
            referralType,
            sleepScreenerAccess,
        })),

    }
}
export default connect(mapStateToProps, mapDispatchToProps)(profile);